module.exports = __webpack_public_path__ + "static/img/MP@2x.93bb5574.png";